//SLVI-827-FIX-IDOR INICIO
import dataConverter from './dataConverter';

const urlParamsHelper = {
  //SLVI-1334-FIX-05 INICIO
  hasRequiredParams: () => {
    try {
      const urlOrigemBase64 = localStorage.getItem("urlOrigem");

      if (!urlOrigemBase64) {
        return false;
      }

      const urlString = dataConverter.fromBase64(urlOrigemBase64);

      if (!urlString) {
        return false;
      }

      const urlParams = new URLSearchParams(urlString);
      const cpf = urlParams.get('cpf');
      const corsus = urlParams.get('corsus');

      return !!(cpf && corsus);
    } catch (error) {
      console.error('Erro ao verificar parâmetros da URL:', error);
      return false;
    }
  },
//SLVI-1334-FIX-05 FIM
  getParam: (paramName) => {
    try {

        
      const urlOrigemBase64 = localStorage.getItem("urlOrigem");

      if (!urlOrigemBase64) {
        return '';
      }
      
      const urlString = dataConverter.fromBase64(urlOrigemBase64);

      if (!urlString) {
        return '';
      }
      
      const urlParams = new URLSearchParams(urlString);
      const value = urlParams.get(paramName);
      
      return value || '';
      
    } catch (error) {
      console.error('Erro ao buscar parâmetro da URL:', error);
      return '';
    }
  },
};

export default urlParamsHelper;
//SLVI-827-FIX-IDOR FIM
